<div class="text-secondary" style="float:right;position:absolute;right:0px;top:0px;z-index:100;margin:20px;">
    <div *ngIf="isLoggedIn" style="display:inline-block;">
        <span class="text-primary p-2" *ngIf="authService.authenticated">
            {{authService.user.username}}
        </span>
        <button type="button" class="btn btn-light btn-sm" (click)="logout()">
            <span class="fa fa-sign-out"></span> Logout
        </button>
    </div>
    <div *ngIf="!isLoggedIn" style="display:inline-block;">
        <button type="button" class="btn btn-light btn-sm" (click)="login()">
            <span class="fa fa-sign-in"></span> Login
        </button>
    </div>
    <div style="display:inline-block;margin-left:25px;">v{{appVersion}}</div>
</div>
<kendo-appbar themeColor="light" positionMode="fixed" class="k-appbar-light">
    <kendo-appbar-section>
        <h1 class="title"><a [routerLink]="['/home']">ALS Web Portal</a></h1>
    </kendo-appbar-section>
    <kendo-appbar-spacer width="15px"></kendo-appbar-spacer>
    <kendo-appbar-section>
        <kendo-menu *ngIf="isLoggedIn">
            <kendo-menu-item text="Home">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/home']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/home')}">Home</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Carrier Sales">
                <kendo-menu-item text="Carriers">
                    <ng-template kendoMenuItemLinkTemplate>
                        <a [routerLink]="['/carrier-search-grid']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/carrier-search-grid')}">Carriers</a>
                    </ng-template>
                </kendo-menu-item>
                <kendo-menu-item text="Procurement">
                    <ng-template kendoMenuItemLinkTemplate>
                        <a [routerLink]="['/carrier-sales']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/carrier-sales'), '': !isLinkActive('/carrier-sales')}">Procurement</a>
                    </ng-template>
                </kendo-menu-item>
            </kendo-menu-item>
            <kendo-menu-item text="CRM">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/crm-dashboard']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/crm-dashboard')}">CRM</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Customers">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/customer-list']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/customer-list')}">Customers</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Orders">
                <kendo-menu-item text="Order Entry">
                    <ng-template kendoMenuItemLinkTemplate>
                        <a [routerLink]="['/order-entry', 0]" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/order-entry/')}">Order Entry</a>
                    </ng-template>
                </kendo-menu-item>
                <kendo-menu-item text="Planned Orders">
                    <ng-template kendoMenuItemLinkTemplate>
                        <a [routerLink]="['/order-planned']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/order-planned')}">Planned Orders</a>
                    </ng-template>
                </kendo-menu-item>
            </kendo-menu-item>
            <kendo-menu-item text="Tracking">
                <kendo-menu-item text="Track and Trace">
                    <ng-template kendoMenuItemLinkTemplate>
                        <a [routerLink]="['/tracking-dashboard']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/tracking-dashboard')}">Track &amp; Trace</a>
                    </ng-template>
                </kendo-menu-item>
                <kendo-menu-item text="Cross Border">
                    <ng-template kendoMenuItemLinkTemplate>
                        <a [routerLink]="['/cross-border']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/cross-border')}">Cross Border</a>
                    </ng-template>
                </kendo-menu-item>
            </kendo-menu-item>
            <kendo-menu-item text="System Settings" *showRolesIf="'System Admin'">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings')}"><i class="fas fa-cog"></i> Settings</a>
                </ng-template>
            </kendo-menu-item>
        </kendo-menu>
    </kendo-appbar-section>
</kendo-appbar>
